import { MappableModel } from '@se-po/shared-data-access-models'

export interface Money {
  currency: string
  dollars: number
  cents: number
}

export class Money implements Money {
  constructor(amount: number, currency = 'USD') {
    if (amount === undefined || amount === null) return

    const parts = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      currencyDisplay: 'symbol',
      useGrouping: false,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).formatToParts(amount / 100)
    this.currency = parts.find(part => part.type === 'currency')!.value
    this.dollars = Number(parts.find(part => part.type === 'integer')!.value)
    this.cents = Number(parts.find(part => part.type === 'fraction')!.value)
  }

  public get amountString(): string {
    const dollarString = this.dollars?.toString() || '0'
    const centsString = this.cents?.toString().padStart(2, '0') || '00'
    return `${this.currency}${dollarString}.${centsString}`
  }
}

export class Tag {
  constructor(
    public color?: string,
    public value?: string
  ) { }
}

export class FinancialSummary extends MappableModel {
  public id: number
  public amount: number
  public description: string
  public dueDate: string | null
  public href: string
  public sourceType: string
  public currency: string
  public state: string[]
  public paymentDescription?: string
  public view_sale: boolean
  public tags: Tag[]
  public money: Money

  public constructor(data: any) {
    super(data)
    this.money = new Money(this.amount, this.currency)
  }

  public get paymentSubtitleTranslationKey(): string {
    if (!this.dueDate) return 'DASHBOARD.PAYMENTS.due_date_unavailable'
    return this.state.includes('AutoPay')
      ? 'DASHBOARD.PAYMENTS.scheduled'
      : 'DASHBOARD.PAYMENTS.payment_due'
  }
}
